import React from "react";
import styles from "./index.module.less";
import BaseCard from "../components/BaseCard";

interface IProps {
  key: string;
  cardInfo: any;
}

function NotFoundCard (props: IProps) {
  const { cardInfo } = props;
  return (
    <BaseCard className={styles["not-found-container"]}>
      <div>
        <div className={styles["not-found-header"]}>
          <div className={styles["not-found-header-title"]}>
            <img className={styles["card-logo"]} src={cardInfo?.icon} alt="" />
            <span className={styles["title"]}>{cardInfo?.name || ""}</span>
          </div>
        </div>
        {/* <img src={notFoundNetwork} /> */}
        <div className={styles["not-found-content"]}>当前版本不支持</div>
      </div>
    </BaseCard>
  );
}

export default NotFoundCard;
